module.exports = __webpack_public_path__ + "static/img/logo_white.7c9f810.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/foot/logo_white.png
// module id = JVX8
// module chunks = 7